import {MathJax, MathJaxContext} from "better-react-mathjax";
import {isNullOrUndefined} from "../../../services/Validator";

export default function DetailedCourseExampleExplanationText({exampleExplanation}) {
    // Used in DetailedCourseLevelAKnowledgeExample to display
    // exampleQuestion text

    // BUILD
    if (isNullOrUndefined(exampleExplanation))
        return null
    return (
        <div className={"w-full mt-[6px]"}>
            <MathJaxContext>
                <MathJax inline dynamic>
                    <span className={'whitespace-pre-line font-semibold text-white text-[16px]'}>
                        {exampleExplanation}
                    </span>
                </MathJax>
            </MathJaxContext>
        </div>
    );
}